import * as React from 'react';

const ErrorIcon: React.FC = () => {
  return (
    <svg
      aria-label="error"
      data-type="error-message"
      fill="none"
      height="24"
      viewBox="0 0 48 48"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.3476 43L23.5001 3.46631L1.65247 43H45.3476ZM43.6525 42L23.5001 5.53377L3.34764 42H43.6525ZM24.0001 18H23.0001V29H24.0001V18ZM23.0001 33V37H24.0001V33H23.0001Z"
        fill="none"
        stroke="#eb0d3f"
        strokeWidth="1"
      />
    </svg>
  );
};

export default ErrorIcon;
